import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from 'src/environments/environment';
import { Team } from "../models/team";
import { TeamMemberDetails } from "../models/team-member-details";
import { PagedAlertsResponse } from "../models/paged-alerts-response";

@Injectable({
  providedIn: 'root',
})
export class OnCallService {
  constructor(private http: HttpClient) { }

  getTeams(): Observable<Team[]> {
    const url = `${environment.oncallapi.teamsUri}`;
    return this.http.get<Team[]>(url, {
      observe: 'body',
    });
  }

  getTeam(teamName: string): Observable<Team> {
    const url = `${environment.oncallapi.teamsUri}?teamName=${teamName}`;
    return this.http.get<Team>(url, {
      observe: 'body',
    });
  }

  getAlerts(status: string, teamName: string, pageSize: number, continuationToken: string): Observable<PagedAlertsResponse> {
    const url = `${environment.oncallapi.alertUri}?teamName=${teamName}&status=${status}&pageSize=${pageSize}&continuationToken=${continuationToken}`;
    return this.http.get<PagedAlertsResponse>(url, {
      observe: 'body',
    });
  }

  performAlertAction(id: string, action: string): Observable<HttpResponse<any>> {
    const url = `${environment.oncallapi.alertNotificationUri}/${action}/${id}`;
    return this.http.post<any>(url, {
      observe: 'response',
    });
  }

  createOrUpdateTeam(team: Team): Observable<HttpResponse<any>> {
    const url = `${environment.oncallapi.teamsUri}`;
    return this.http.put<Team>(url, team, {
      observe: 'response',
    });
  }

  deleteTeam(name: string): Observable<HttpResponse<any>> {
    const url = `${environment.oncallapi.teamsUri}/${name}`;
    return this.http.delete<any>(url, {
      observe: 'response',
    });
  }

  createOrUpdateTeamMemberDetails(id: string, teamMemberDetails: TeamMemberDetails): Observable<HttpResponse<any>> {
    const url = `${environment.oncallapi.teamMemberDetailsUri}/${id}`;
    return this.http.put<TeamMemberDetails>(url, teamMemberDetails, {
      observe: 'response',
    });
  }

  getTeamMemberDetails(id: string): Observable<TeamMemberDetails> {
    const url = `${environment.oncallapi.teamMemberDetailsUri}/${id}`;
    return this.http.get<TeamMemberDetails>(url, {
      observe: 'body',
    });
  }

  getAllTeamMemberDetails(): Observable<TeamMemberDetails[]> {
    const url = `${environment.oncallapi.teamMemberDetailsUri}`;
    return this.http.get<TeamMemberDetails[]>(url, {
      observe: 'body',
    });
  }

  deleteTeamMemberDetails(id: string): Observable<HttpResponse<any>> {
    const url = `${environment.oncallapi.teamMemberDetailsUri}/${id}`;
    return this.http.delete<any>(url, {
      observe: 'response',
    });
  }

  testWorkflow(workflow: any): Observable<HttpResponse<any>> {
    const url = `${environment.oncallapi.workflowUri}`;
    return this.http.post<any>(url, workflow, {
      observe: 'response',
    });
  }

  sendAlertToOnCall(teamName: string, body: any): Observable<HttpResponse<any>> {
    const url = `${environment.oncallapi.alertNotificationUri}/${teamName}`;
    return this.http.post<any>(url, body, {
        observe: 'response',
    });
  }
}
